import getModileOperatingSystem from './GetMobileOperatingSystem';

/**
 *
 * @returns {Boolean} Возвращает true, если текущая операционная система мобильная, иначе - false
 */
const isMobileSystem = () => getModileOperatingSystem() === 'Android' || getModileOperatingSystem() === 'iOS';

export default isMobileSystem;
